(() => {
  angular
    .module('complianceFrameworkApp.socialMediaCompliance')
    .controller('BrandMonitorsController', BrandMonitorsController);

  /* ngInject */
  function BrandMonitorsController($state, Flash, sessionService, brandMonitorService) {
    const vm = this;

    vm.brandMonitors = [];
    vm.deleteBrandMonitor = deleteBrandMonitor;

    activate();

    function activate() {
      getBrandMonitors();
    }

    function deleteBrandMonitor(brandMonitor) {
      brandMonitorService(sessionService.getAuthToken()).destroy({ id: brandMonitor.id }, _ => {
        Flash.create('success', 'Brand monitor successfully deleted.');
        $state.reload();
      });
    }

    function getBrandMonitors() {
      brandMonitorService(sessionService.getAuthToken()).query(response => vm.brandMonitors = response);
    }
  }
})();
